export type SectionName = 'performance' | 'setlists' | 'library' | 'metronome' | 'settings';

const SECTIONS: SectionName[] = ['performance', 'setlists', 'library', 'metronome', 'settings'];

export function getCurrentSection(): SectionName {
  const path = window.location.hash.replace(/^#\//, '');
  const [first] = path.split('/');
  return SECTIONS.includes(first as SectionName) ? (first as SectionName) : 'performance';
}

export function navigateTo(section: SectionName): void {
  window.location.hash = `#/${section}`;
}

export function onRouteChange(handler: (section: SectionName) => void): () => void {
  const listener = () => handler(getCurrentSection());
  window.addEventListener('hashchange', listener);
  return () => window.removeEventListener('hashchange', listener);
}

export type SettingsTab = 'diagnostics' | 'account' | 'about';

export function getCurrentSettingsTab(): SettingsTab {
  const path = window.location.hash.replace(/^#\//, '');
  if (path.split('/')[1] === 'account') return 'account';
  if (path.split('/')[1] === 'about') return 'about';
  return 'diagnostics';
}

export function navigateToSettingsTab(tab: SettingsTab): void {
  window.location.hash =
    tab === 'account'
      ? '#/settings/account'
      : tab === 'about'
        ? '#/settings/about'
        : '#/settings';
}
